export const FileHelper = {
  ConvertFileToBase64,
  DownloadFile,
  ViewFileFromResponse,
  ViewFileFromDirectory,
  DownloadUnsavedFile,
};

function ConvertFileToBase64(file) {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  return new Promise((resolve, reject) => {
    reader.onload = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result.split(",")[1]); //dont want the data:"mime" part
      } else {
        reject(new Error("File could not be converted to base64 string."));
      }
    };
    reader.onerror = (error) => reject(error);
  });
}

function DownloadFile(response) {
  const fileName = getFileNameFromContentDisposition(response.headers["content-disposition"])
  DownloadFileHelper(fileName, response.data)
}

function DownloadUnsavedFile(name, data) {
  DownloadFileHelper(name, data)
}

function DownloadFileHelper(name, data) {
  const actualFileName = name;
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.rel = "noopener noreferrer";
  link.target = "_blank";
  link.setAttribute("download", actualFileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function getFileNameFromContentDisposition(contentDisposition) {
  if (!contentDisposition) return null;

  const match = contentDisposition.match(/filename="?([^"]+)"?;/);
  if (match) return match[1];
  else {
    const matchTwo = contentDisposition.match(/filename="?([^"]+)"?/);
    return matchTwo ? matchTwo[1] : null;
  }
}

function ViewFileFromResponse(response) {
  ViewFile(window.URL.createObjectURL(response.data))
}

function ViewFileFromDirectory(file) {
  ViewFile(file)
}

function ViewFile(href) {
  const link = document.createElement("a");
  link.href = href;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  link.remove();
}
